import React, { memo } from "react";
import { useParams } from "react-router-dom";

import Form from "./components/form";

const CreateAndEdit = () => {
  const { id } = useParams<any>();

  return (
    <div className="firmwares-container firmwares-modifi-container">
      <div className="title">
        {id !== 'create' ? "Cập nhật thiết bị" : "Tạo mới thiết bị"}
      </div>

      <Form />
    </div>
  );
};

export default memo(CreateAndEdit);
